import script from "./FileClass.vue?vue&type=script&setup=true&lang=js"
export * from "./FileClass.vue?vue&type=script&setup=true&lang=js"

import "./FileClass.vue?vue&type=style&index=0&id=6003f74a&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6003f74a"]])

export default __exports__